import React, { useContext, useState } from 'react';
import { Switch, Title, Text, theme } from 'components';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { toggleAccessBill } from 'api/OrgController';
import errorReporter from '@app/errorReporter';
import { AuthContext } from 'contexts';

type AccessBillRoleType =
  | 'globalAdminCanAccessBilling'
  | 'managerCanAccessBilling';

const PermissionsTab = () => {
  const { md } = useBreakpoint();
  const {
    auth: {
      org: { globalAdminCanAccessBilling, managerCanAccessBilling },
    },
    setAuth,
  } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState({
    globalAdminCanAccessBilling: false,
    managerCanAccessBilling: false,
  });

  const handleToggle = async (
    checked: boolean,
    accessBillRoleType: AccessBillRoleType,
  ) => {
    try {
      setIsLoading(prev => ({ ...prev, [accessBillRoleType]: true }));

      await toggleAccessBill({ [accessBillRoleType]: checked });
      setAuth(prev => {
        const newAuth = { ...prev };
        newAuth.org[accessBillRoleType] = checked;
        return newAuth;
      });
    } catch (err) {
      errorReporter.error('Error toggle accessBill', err);
    } finally {
      setIsLoading(prev => ({ ...prev, [accessBillRoleType]: false }));
    }
  };

  return (
    <StyledContainer $md={md}>
      <Title level={3}>{'Billing & Subscriptions'}</Title>
      <SwitchContainer>
        <Switch
          checked={managerCanAccessBilling}
          onChange={checked => handleToggle(checked, 'managerCanAccessBilling')}
          loading={isLoading.managerCanAccessBilling}
          data-cy="access=bill-enable-manager"
        />
        <StyledText>Manager has edit access</StyledText>
      </SwitchContainer>
      <SwitchContainer>
        <Switch
          checked={globalAdminCanAccessBilling}
          onChange={checked =>
            handleToggle(checked, 'globalAdminCanAccessBilling')
          }
          loading={isLoading.globalAdminCanAccessBilling}
          data-cy="access-bill-enable-ga"
        />
        <StyledText>Global Admin has edit access</StyledText>
      </SwitchContainer>
    </StyledContainer>
  );
};

export default PermissionsTab;

const SwitchContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin: 15px 0;
`;

const StyledText = styled(Text)`
font-size: 14px color: ${theme.gray10}`;

const StyledContainer = styled.div<{ $md: boolean }>`
  background-color: white;
  width: 100%;
  padding: ${({ $md }) => ($md ? '40px 0 40px 250px' : '30px')};
`;
